export enum CompanyPerfomanceVsIpoIndexChartActionsBlock {
  Root = 'CompanyPerfomanceVsIpoIndexChartActions',
}
